import { useState } from "react";
import { MessageCircle, Mail, X, Phone } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

const WHATSAPP_NUMBER = "972528614433";
const CONTACT_EMAIL = "mart@mart-mineral.com";

export const ContactFloat = () => {
  const { language } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const isRTL = language === 'he';

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
    isRTL ? "היי, יש לי שאלה לגבי M'ART" : "Hi, I have a question about M'ART"
  )}`;

  return (
    <div className="fixed bottom-6 left-6 z-40" dir={isRTL ? 'rtl' : 'ltr'}>
      {/* Expanded Options */}
      {isOpen && (
        <div className="mb-3 flex flex-col gap-2 animate-fade-in-up">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="float-whatsapp-btn"
            className="flex items-center gap-3 px-5 py-3 bg-white rounded-full shadow-lg border border-[#E8E4DC] hover:border-[#25D366] hover:shadow-xl transition-all group"
          >
            <div className="w-9 h-9 bg-[#25D366] rounded-full flex items-center justify-center shrink-0">
              <MessageCircle className="w-4.5 h-4.5 text-white" />
            </div>
            <div className="text-right">
              <p className="text-sm font-medium text-[#2C3329]">WhatsApp</p>
              <p className="text-[11px] text-[#6B7266]">{isRTL ? 'תשובה מהירה' : 'Quick response'}</p>
            </div>
          </a>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="float-email-btn"
            className="flex items-center gap-3 px-5 py-3 bg-white rounded-full shadow-lg border border-[#E8E4DC] hover:border-[#4A5D43] hover:shadow-xl transition-all group"
          >
            <div className="w-9 h-9 bg-[#4A5D43] rounded-full flex items-center justify-center shrink-0">
              <Mail className="w-4.5 h-4.5 text-white" />
            </div>
            <div className="text-right">
              <p className="text-sm font-medium text-[#2C3329]">{isRTL ? 'אימייל' : 'Email'}</p>
              <p className="text-[11px] text-[#6B7266]">{CONTACT_EMAIL}</p>
            </div>
          </a>
        </div>
      )}

      {/* Toggle Button */}
      <button
        data-testid="contact-float-toggle"
        onClick={() => setIsOpen(!isOpen)}
        className={`w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 ${
          isOpen 
            ? 'bg-[#2C3329] rotate-0' 
            : 'bg-[#C47F64] hover:bg-[#b06d53]'
        }`}
      >
        {isOpen ? (
          <X className="w-5 h-5 text-white" />
        ) : (
          <Phone className="w-5 h-5 text-white" />
        )}
      </button>
    </div>
  );
};
